import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check, CircleAlert } from "lucide-react";
import { api } from "../lib/api";

/** What is legally open, counted from the live records — so nothing waits unseen. */
export const CompliancePanel = () => {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/admin/compliance").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);

  if (!d) return null;

  return (
    <section className="mt-12 border border-zinc-900 bg-ink-surface p-7" data-testid="compliance-panel">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="overline">{d.heading}</p>
          <p className="mt-3 max-w-2xl text-xs leading-relaxed text-zinc-500">{d.note}</p>
        </div>
        <span
          className={`mono border px-4 py-2 text-[0.55rem] uppercase tracking-[0.16em] ${
            d.all_clear ? "border-ochre text-ochre" : "border-maasai text-maasai"
          }`}
          data-testid="compliance-open-count"
        >
          {d.all_clear ? "Nothing open" : `${d.open_count} open`}
        </span>
      </div>

      <ul className="mt-7 space-y-px bg-zinc-800" data-testid="compliance-items">
        {d.items.map((i) => (
          <li key={i.key} className="grid gap-4 bg-ink-surface p-5 md:grid-cols-[auto_1fr_auto] md:items-center"
            data-testid={`compliance-item-${i.key}`}>
            <span className={`font-display text-3xl font-bold leading-none ${
              i.status === "clear" ? "text-zinc-600" : "text-maasai"
            }`} data-testid={`compliance-count-${i.key}`}>
              {i.count}
            </span>
            <div>
              <p className="flex items-center gap-2 text-sm text-white">
                {i.status === "clear"
                  ? <Check size={13} className="text-ochre" />
                  : <CircleAlert size={13} className="text-maasai" />}
                {i.label}
              </p>
              <p className="mt-1 text-xs leading-relaxed text-zinc-500">{i.detail}</p>
            </div>
            <Link to={i.link} data-testid={`compliance-link-${i.key}`}
              className="mono inline-flex items-center gap-2 border border-zinc-800 px-4 py-2.5 text-[0.55rem] uppercase tracking-[0.14em] text-zinc-300 transition-colors hover:border-ochre hover:text-ochre">
              {i.link_label} <ArrowRight size={12} />
            </Link>
          </li>
        ))}
      </ul>

      {d.withdrawn_consents ? (
        <p className="mt-6 text-xs text-zinc-500" data-testid="compliance-withdrawn">
          {d.withdrawn_consents} consent{d.withdrawn_consents === 1 ? " has" : "s have"} been withdrawn and are
          kept on record.{" "}
          <Link to="/admin/consent-log" className="text-ochre underline">Consent log</Link>.
        </p>
      ) : null}
    </section>
  );
};

export default CompliancePanel;
